import { useRef } from "react";
import { motion, useMotionTemplate, useSpring } from "framer-motion";

// Wraps children in a card that tilts in 3D toward the cursor and carries
// a soft light-glare highlight that follows the pointer — disabled on
// touch/coarse-pointer devices where there is no hover to react to.
const TiltCard = ({ children, className = "", intensity = 14, glare = true }) => {
  const ref = useRef(null);

  const rotateX = useSpring(0, { stiffness: 150, damping: 15, mass: 0.5 });
  const rotateY = useSpring(0, { stiffness: 150, damping: 15, mass: 0.5 });
  const glareX = useSpring(50, { stiffness: 150, damping: 20 });
  const glareY = useSpring(50, { stiffness: 150, damping: 20 });

  const handleMouseMove = (e) => {
    const el = ref.current;
    if (!el || !window.matchMedia("(pointer: fine)").matches) return;
    const rect = el.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width;
    const py = (e.clientY - rect.top) / rect.height;

    rotateY.set((px - 0.5) * intensity);
    rotateX.set(-(py - 0.5) * intensity);
    glareX.set(px * 100);
    glareY.set(py * 100);
  };

  const handleMouseLeave = () => {
    rotateX.set(0);
    rotateY.set(0);
  };

  const glareBackground = useMotionTemplate`radial-gradient(circle at ${glareX}% ${glareY}%, rgba(255,255,255,0.35), transparent 60%)`;

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        rotateX,
        rotateY,
        transformStyle: "preserve-3d",
        transformPerspective: 1000,
      }}
      className={`relative ${className}`}
    >
      {children}
      {glare && (
        <motion.div
          aria-hidden
          className="pointer-events-none absolute inset-0 rounded-[inherit] mix-blend-overlay"
          style={{ background: glareBackground }}
        />
      )}
    </motion.div>
  );
};

export default TiltCard;
